import { IStepInfo } from '@cont/Course/CourseHeader/AddCourseToPlanner/AllCustomizationSteps';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import { FC } from 'react';

const CarouselStepBlock = styled.div<{ $isCompleted: boolean }>`
  width: ${Spacings.SPACING_7B};
  height: ${Spacings.SPACING_3};
  border-radius: 20px;
  margin-right: ${Spacings.SPACING_1B};
  background: ${({ $isCompleted }) =>
    $isCompleted ? 'var(--color-base-fill)' : 'var(--color-divider)'};
`;

const Wrapper = styled.div`
  display: flex;
  margin-top: ${Spacings.SPACING_4B};
`;

interface IStepCustomisationCarouselProps {
  steps: IStepInfo[];
  currentStepId: string;
}

const StepCustomisationCarousel: FC<IStepCustomisationCarouselProps> = ({
  steps,
  currentStepId
}) => {
  const currentStepIdIndex = steps.findIndex((x) => x.id === currentStepId);
  return (
    <Wrapper>
      {steps.map((step, stepIndex) => (
        <CarouselStepBlock
          $isCompleted={stepIndex <= currentStepIdIndex}
          key={step.id}
        />
      ))}
    </Wrapper>
  );
};

export default StepCustomisationCarousel;
